<form
  class="space-y-3"
  [formGroup]="form">
  <div class="bg-bg-surface-default space-y-5 rounded-xl p-8">
    <div class="pb-2">
      <h1 class="text-text-default text-lg font-bold">Informasi Karyawan</h1>
      <p class="text-text-subtler text-sm">Struktur posisi, unit kerja, dan jenis kontrak.</p>
    </div>
    <div class="border-line-default border-b"></div>
    <div class="grid grid-cols-3 gap-5">
      <p class="text-text-default text-sm font-semibold">Divisi Inti</p>
      <div class="col-span-2">
        <div class="space-y-1">
          <app-input-select
            class="block"
            formControlName="divisi_id"
            placeholder="Pilih Divisi"
            [options]="divisiOptions"
            [loading]="divisiOptionsFetching"
            (ngModelChange)="_onDivisiChange()" />
          @if (formError.divisi_id.msg) {
            <p class="text-text-error text-xs">{{ formError.divisi_id.msg }}</p>
          }
        </div>
      </div>
    </div>
    @if (form.value.divisi_id) {
      <div class="border-line-default border-b"></div>
      <div class="grid grid-cols-3 gap-5">
        <p class="text-text-default text-sm font-semibold">
          Departemen <span class="text-text-subtler">(Opsional)</span>
        </p>
        <div class="col-span-2">
          <div class="space-y-1">
            <app-input-select
              class="block"
              formControlName="sub_divisi_id"
              placeholder="Pilih Departemen"
              [options]="subDivisiOptions"
              [loading]="subDivisiOptionsFetching"
              (ngModelChange)="formService.resetError(formError, 'sub_divisi_id')" />
            @if (formError.sub_divisi_id.msg) {
              <p class="text-text-error text-xs">{{ formError.sub_divisi_id.msg }}</p>
            }
          </div>
        </div>
      </div>
    }
    <div class="border-line-default border-b"></div>
    <div class="grid grid-cols-3 gap-5">
      <p class="text-text-default text-sm font-semibold">Jabatan</p>
      <div class="col-span-2">
        <div class="space-y-1">
          <app-input-select
            class="block"
            formControlName="level_id"
            placeholder="Pilih Jabatan"
            [options]="jabatanOptions"
            [loading]="jabatanOptionsFetching"
            (ngModelChange)="formService.resetError(formError, 'level_id')" />
          @if (formError.level_id.msg) {
            <p class="text-text-error text-xs">{{ formError.level_id.msg }}</p>
          }
        </div>
      </div>
    </div>
    <div class="border-line-default border-b"></div>
    <div class="grid grid-cols-3 gap-5">
      <p class="text-text-default text-sm font-semibold">Lokasi Penempatan</p>
      <div class="col-span-2">
        <div class="space-y-1">
          <app-input-select
            class="block"
            formControlName="lokasi_id"
            placeholder="Pilih Lokasi Penempatan"
            [options]="lokasiOptions"
            [loading]="lokasiOptionsFetching"
            (ngModelChange)="formService.resetError(formError, 'lokasi_id')" />
          @if (formError.lokasi_id.msg) {
            <p class="text-text-error text-xs">{{ formError.lokasi_id.msg }}</p>
          }
        </div>
      </div>
    </div>
    <div class="border-line-default border-b"></div>
    <div class="grid grid-cols-3 gap-5">
      <p class="text-text-default text-sm font-semibold">Kontrak</p>
      <div class="col-span-2">
        <div class="space-y-1">
          <app-input-select
            class="block"
            formControlName="kontrak_id"
            placeholder="Pilih Kontrak"
            [options]="kontrakOptions"
            [loading]="kontrakOptionsFetching"
            [(search)]="kontrakOptionsSearch"
            (searchChange)="_getKontrakOptions()"
            (ngModelChange)="formService.resetError(formError, 'kontrak_id')" />
          @if (formError.kontrak_id.msg) {
            <p class="text-text-error text-xs">{{ formError.kontrak_id.msg }}</p>
          }
        </div>
      </div>
    </div>
    <div class="border-line-default border-b"></div>
    <div class="grid grid-cols-3 gap-5">
      <div class="space-y-1">
        <p class="text-text-default text-sm font-semibold">Tanggal Bergabung</p>
        <p class="text-text-subtler text-xs">
          Tanggal bergabung pertama kali akan juga dicatat sebagai tanggal mulai kontrak
        </p>
      </div>
      <div class="col-span-2 space-y-2">
        <div class="space-y-1">
          <app-input-date
            class="block"
            formControlName="join_date"
            placeholder="Pilih Tanggal Bergabung"
            dateFormat="dd MMM y"
            defaultValue="2000-01-01"
            (ngModelChange)="formService.resetError(formError, 'join_date')">
            <!-- @if (form.value.join_date) {
              <div
                template="suffix"
                class="shrink-0 p-2">
                <p class="bg-alpha-on-surface text-text-subtler rounded-xl px-1.5 text-xs">
                  {{ form.value.join_date | diffYear }}
                </p>
              </div>
            } -->
          </app-input-date>
          @if (formError.join_date.msg) {
            <p class="text-text-error text-xs">{{ formError.join_date.msg }}</p>
          }
        </div>
      </div>
    </div>
    @if (!isEdit) {
      <div class="border-line-default border-b"></div>
      <div class="grid grid-cols-3 gap-5">
        <div class="space-y-1">
          <p class="text-text-default text-sm font-semibold">Saldo Cuti Awal</p>
          <p class="text-text-subtler text-xs">
            Masukan jumlah saldo cuti, isi 0 jika karyawan tidak miliki saldo cuti.
          </p>
        </div>
        <div class="col-span-2 space-y-2">
          <div class="space-y-1">
            <app-input-number
              class="block"
              formControlName="saldo_cuti_awal"
              placeholder="Masukkan Saldo Cuti"
              [useGrouping]="false"
              (ngModelChange)="formService.resetError(formError, 'saldo_cuti_awal')">
              <div
                template="suffix"
                class="shrink-0 p-2">
                <p class="text-text-subtle text-xs">Hari</p>
              </div>
            </app-input-number>
            @if (formError.saldo_cuti_awal.msg) {
              <p class="text-text-error text-xs">{{ formError.saldo_cuti_awal.msg }}</p>
            }
          </div>
        </div>
      </div>
    }
  </div>
  <div class="flex items-center justify-between gap-3">
    <app-button
      theme="outline"
      class="block w-32"
      styleClass="bg-bg-surface-default"
      (click)="back.emit()">
      Kembali
    </app-button>
    <app-button
      class="ml-auto block w-32"
      (click)="_next()">
      Selanjutnya
    </app-button>
  </div>
</form>
